import { render, staticRenderFns } from "./scertificate.vue?vue&type=template&id=4efb6269&scoped=true&"
import script from "./scertificate.vue?vue&type=script&lang=js&"
export * from "./scertificate.vue?vue&type=script&lang=js&"
import style0 from "./scertificate.vue?vue&type=style&index=0&id=4efb6269&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efb6269",
  null
  
)

export default component.exports